import React from 'react';
import Footer from './Footer';

const Contact = () => {
  return (
    <section
      id="contact"
      className="container mx-auto h-card flex flex-col justify-end items-center px-8 mt-32 sm:mt-64"
    >
      <h2 className="capitalize font-curl text-4xl sm:text-6xl mb-4 px-6 sm:px-0">
        Get in touch
      </h2>

      <div className="border-4 border-dotted border-indigo-700 sm:mx-0 px-2 py-5 lg:px-20 lg:py-10 font-mono text-xs sm:text-2xl">
        If you'd like to get in touch
        <a
          href="mailto:agugodis@gmail.com"
          className="inline-block bg-indigo-700 px-1 py-1 md:px-3 md:py-2 rounded ml-2 sm:ml-4"
        >
          <span
            className="text-xs sm:text-lg md:text-3xl text-white"
            role="img"
            aria-label="sheep"
          >
            Say Hi 👋
          </span>
        </a>
      </div>
      <Footer />
    </section>
  );
};

export default Contact;
